import { useTranslation } from "react-i18next";
import { useSelector } from "src/store";

import { selectGroups } from "@dashboard/groups/store/selectors";
import { getNestedGroupsWithIndentation } from "@dashboard/groups/utils";
import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { PermissionService } from "@services/permissionService/permissionService";
import { SelectOption } from "@shared/form/SelectField/SelectField.types";

export const useVisibilityOptions = () => {
    const { t } = useTranslation(["common"]);
    const { data: workspace } = useCurrentWorkspace();
    const workspaceGroups = useSelector(selectGroups);
    const { workspaceAbility, groupAbility } = PermissionService();
    const canManageWorkspace = workspaceAbility(workspace).can("manage", "File");

    let workspaceOptions: SelectOption[] = [];

    if (workspace && canManageWorkspace) {
        workspaceOptions = [
            {
                label: workspace.name,
                value: workspace.id,
                category: t("common:label.workspace"),
            },
        ];
    }

    const accessibleGroups = workspaceGroups.filter((group) => groupAbility(group, workspace).can("manage", "File"));
    const groupOptions: SelectOption[] = getNestedGroupsWithIndentation(accessibleGroups).map((group) => ({
        ...group,
        category: t("common:label.groups"),
    }));

    return [...workspaceOptions, ...groupOptions];
};
